import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../redux/actions/ApplicationAction";
import notify from "../../../Notifcation";
import { useNavigate } from "react-router-dom";

const Masaed = () => {
  const [desc, setdesc] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [BuildLec, setBuildLec] = useState("");
  const [elevakd, setelevakd] = useState("");
  const [Companymes, setCompanymes] = useState("");
  const [elevdraw, setelevdraw] = useState("");
  const [Arthimiticnote, setArthimiticnote] = useState("");
  const [elevwork, setelevwork] = useState("");
  const [Power, setPower] = useState("");
  const [Engreport, setEngreport] = useState("");

  const [ChoseServ, setChoseServ] = useState("");

  const [Others, setOthers] = useState([]);
  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  // const handleFileChangeelevakd = (e) => {
  //   // Convert FileList to Array
  //   const files = Array.from(e.target.files);
  //   setelevakd(files);
  // };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (BuildLec === ""||Nationalid==="") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 7);
    formData.append("local_type", 5);
    formData.append("local_category", ChoseServ);
    formData.append("local_details", desc);
    formData.append("construction_license", BuildLec);
    formData.append("elevator_installation_contract",elevakd );
    formData.append("elevator_company_registration_classification_card",Companymes );
    formData.append("technical_engineering_specifications_file",elevdraw );
    formData.append("assessment_includes_business",elevwork );
    formData.append("arithmetic_note",Arthimiticnote );
    formData.append("power_attoreny",Power );
    formData.append("structural_engineer_report",Engreport );

    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });

    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setdesc("");
    setNationalid("");
    setBuildLec("");
    setelevakd("");
    setCompanymes("");
    setelevdraw("");
    setArthimiticnote("");
    setelevwork("");
    setPower("");
    setEngreport("");

    setChoseServ("");

    setOthers("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">خدمات المصاعد</h3>
      <div className="inputs-container">
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServ}
              onChange={(e) => setChoseServ(e.target.value)}
            >
              <MenuItem value={14}>طلب الحصول على تركيب مصعد</MenuItem>
              <MenuItem value={15}>طلب الحصول على رخصة تشغيل مصعد</MenuItem>
            </Select>
          </FormControl>
        </div>
        {/* {ChoseServ===1?(
        <div className="inp-container">
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={
                <Typography>
                  نوع الخدمة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              value={ChoseServSub}
              onChange={(e) => setChoseServSub(e.target.value)}
            >
              <MenuItem value={'construction'}>انشاء</MenuItem>
              <MenuItem value={'amendment'}>تعديل</MenuItem>
              <MenuItem value={'addition'}>اضافة</MenuItem>
              <MenuItem value={'external_finishes'}>تشطيبات خارجية</MenuItem>
              <MenuItem value={'complete'}>استكمال</MenuItem>
              <MenuItem value={'raising'}>تعلية</MenuItem>

            </Select>
          </FormControl>
        </div>
        ):(null)} */}
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                صورة من ترخيص البناء
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setBuildLec(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              "عقد تركيب المصعد من احد الشركات مع صورة من تصريح مزاولة المهنة "
            }
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e)=>setelevakd(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              "صورة من بطاقة قيد وتصنيف شركة المصاعد بالأتحاد المصري لمقاولي التنفيذ والبناء"
            }
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setCompanymes(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"ملف الموصفات الفنية والرسومات الهندسية"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setelevdraw(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"نوتة الحسابات"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setArthimiticnote(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"مقاييس تتضمن الأعمال"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setelevwork(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"توكيل رسمي مقدم"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setPower(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تقرير من مهندس انشائي"}
            focused
            // inputProps={{
            //   multiple: true,
            // }}
            type="file"
            onChange={(e) => setEngreport(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>

        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div>
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default Masaed;
